import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsObjectTypeSettingsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(/* webpackChunkName: "async-assets-object-type-settings-entrypoint" */ './index.tsx'),
	),
	getPreloadProps: () => ({}),
});
